import { render } from "./ZoomIcon.vue?vue&type=template&id=debe1c7e"
import script from "./ZoomIcon.vue?vue&type=script&lang=js"
export * from "./ZoomIcon.vue?vue&type=script&lang=js"
script.render = render

export default script